module.exports = __webpack_public_path__ + "img/mail.260cb588.png";